/** Available "Iron Logic" command statuses */
export enum IronLogicCommandStatusEnum {
  /** Command added to queue */
  SCHEDULED = 'SCHEDULED',
  /** Command handling by converter */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Command succeed */
  SUCCEED = 'SUCCEED',
  /** Command failed */
  FAILED = 'FAILED',
  /** Command expired */
  EXPIRED = 'EXPIRED',
}
